/* Equipe: membros e convites. */
import { inviteMemberInput, member, updateMemberRoleInput, type Member } from "@zapir/shared";
import { request } from "./core";

export const teamApi = {
  async members(): Promise<Member[]> {
    return request("/members", { schema: member.array() });
  },

  async inviteMember(input: { email: string; role: Member["role"] }): Promise<void> {
    await request("/invites", { method: "POST", body: inviteMemberInput.parse(input) });
  },

  async updateMemberRole(userId: string, role: Member["role"]): Promise<void> {
    await request(`/members/${userId}`, { method: "PATCH", body: updateMemberRoleInput.parse({ role }) });
  },
};
